import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import SelectPdfDatesWidget from "../../widgets/SelectPdfDatesWidget";
import SendMailWidget from "../../widgets/SendMailWidget";
import SendNotificationWidget from "../../widgets/SendNotificationWidget";
import GetCorsi from "../../services/getCorsi";
import getStudenti from "../../services/getStudenti";
import getLezioni from "../../services/getLezioni";
import addNotification from "../../services/addNotification";
import updateCorsoStatus from "../../services/updateCorsoStatus";
import sendMail from "../../services/sendMail";
import getSetting from "../../services/getSetting";
import saveFile from "../../services/saveFile";
import Utils from "../../utils/utils";
import moment from "moment";
import "moment/locale/it";
import getCategorieCorsi from "../../services/getCategorieCorsi";

const endLine = "\n";

export default class Corsi extends React.Component {
  constructor(props) {
    super(props);

    // Configura moment.js per l'italiano
    moment.locale("it");

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    // ✅ Recupera i filtri salvati dal localStorage
    const getSavedFilters = () => {
      try {
        const savedCategoria = localStorage.getItem("corsi_selectedCategoria");

        const filters = {
          selectedCategoria: savedCategoria ? JSON.parse(savedCategoria) : null,
        };

        console.log("🔄 [Corsi] Filtri recuperati dal localStorage:", filters);
        return filters;
      } catch (e) {
        console.error("❌ [Corsi] Errore nel recupero dei filtri:", e);
        return {
          selectedCategoria: null,
        };
      }
    };

    const savedFilters = getSavedFilters();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      mailCompaniesList: [],
      selectedCategoria: savedFilters.selectedCategoria, // ✅ Usa il filtro salvato
      optionsCategoria: [],
      corsiFiltrati: [],
    };

    this.grid = 2;

    this.pdfElements = [];

    this.corsi = [];
    this.fusioni = [];
    this.pageTitle = "Corsi";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
  }

  handleCategoriaChange(option) {
    // ✅ Salva il filtro nel localStorage
    console.log("💾 [Corsi] Salvataggio selectedCategoria:", option);
    localStorage.setItem("corsi_selectedCategoria", JSON.stringify(option));

    this.setState({ selectedCategoria: option }, () => {
      this.reload();
    });
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.corsi = await GetCorsi(username, token);
    this.studenti = await getStudenti(username, token);
    this.categorieCorsi = await getCategorieCorsi(username, token);

    this.corsi = this.corsi.map((corso) => {
      const studentiFrequentanti = this.studenti.filter((studente) => {
        const frequentaCorso = studente.corsi
          .split(";")
          .includes(corso.id.toString());
        const nonRitiratoDalCorso = !studente.corsi_ritiro
          .split(";")
          .includes(corso.id.toString());
        return frequentaCorso && nonRitiratoDalCorso;
      }).length;

      // Formattazione date in formato gg/mm/aaaa
      const dateStart = corso.dateStart
        ? moment(corso.dateStart).format("DD/MM/YYYY")
        : "";
      const dateEnd = corso.dateEnd
        ? moment(corso.dateEnd).format("DD/MM/YYYY")
        : "";

      return {
        ...corso,
        frequentanti: studentiFrequentanti,
        dateStart: dateStart,
        dateEnd: dateEnd,
      };
    });

    const { selectedCategoria } = this.state;

    let corsiFiltrati =
      selectedCategoria && selectedCategoria.value !== "seleziona tutti"
        ? this.corsi.filter(
            (corso) => corso.id_categoria === selectedCategoria.value
          )
        : this.corsi;

    const optionsCategoria = this.categorieCorsi.map((categoria) => ({
      value: categoria.id,
      label: categoria.name,
    }));

    this.setState({
      corsiFiltrati,
      optionsCategoria: [
        { label: "SELEZIONA TUTTI", value: "seleziona tutti" },
        ...optionsCategoria,
      ],
    });
  }

  async componentDidMount() {
    await this.reload();

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    if (Utils.checkRegisterWarningToDisplay()) {
      var lezioni = await getLezioni(username, token);

      lezioni = await Utils.filterLessonsWithoutRegisters(lezioni);

      lezioni = lezioni.sort((l1, l2) => {
        var ll1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
        var ll2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
        return ll1 - ll2;
      });

      if (lezioni.length > 0) {
        var alertText =
          "Per le seguenti lezioni non è stato compilato il registro:\n";
        lezioni.forEach(
          (l) => (alertText += l.str_corso + " " + l.data + "\n")
        );
        alert(alertText);
      }

      Utils.updateRegisterWarningToDisplay();
    }
  }

  render() {
    const cookies = new Cookies();

    const corsiFiltrati = this.state.corsiFiltrati || [];

    var headCells = [
      { id: "name", numeric: false, disablePadding: true, label: "Nome" },
      {
        id: "dateStart",
        numeric: true,
        disablePadding: false,
        label: "Data inizio",
      },
      {
        id: "dateEnd",
        numeric: true,
        disablePadding: false,
        label: "Data fine",
      },
      {
        id: "frequentanti",
        numeric: true,
        disablePadding: false,
        label: "Frequentanti",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["name"];

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title="Corsi"
            button="NUOVO"
            // secondButton="ASSENZE"
            onClick={() => {
              window.location.href = "/#/app/addCorso";
            }}
            onSecondClick={() => {
              window.location.href = "/#/app/gestioneAnnunci";
            }}
          />

          <Table
            corsi
            withBilling
            headCells={headCells}
            categorie={this.state.optionsCategoria}
            searchCols={this.searchCols}
            selectedCategoria={this.state.selectedCategoria}
            rows={corsiFiltrati}
            mail={false}
            pdf={false}
            onChangeCategoria={this.handleCategoriaChange}
            phone={false}
            calendar={true}
            onEventClick={(row) => {
              cookies.set("currentCourse", row, { path: "/" });
              window.location.href = "/#/app/editCorso";
            }}
            onBilling={(id) => {
              cookies.set("currentCourse", id, { path: "/" });
              window.location.href = "/#/app/billing/editCorso/";
            }}
            onSendMail={(id) => {
              this.sendMailRef.current && this.sendMailRef.current.reset();
              this.setState({ sendMailVisible: true, sendMailUserId: id });
            }}
            onSendNotification={(id) => {
              this.sendNotificationRef.current &&
                this.sendNotificationRef.current.reset();
              this.setState({
                sendNotificationVisible: true,
                notificationCorso: id,
              });
            }}
            onCalendarClick={(id) => {
              cookies.set("currentCourse", id, { path: "/" });
              window.location.href = "#/app/schedule";
            }}
            onPdfClicked={(elem) => {
              this.setState({
                selectPdfDatesVisible: true,
                pdfElem: elem,
              });
            }}
            onElementCheck={async (companyId) => {
              const cookies = new Cookies();

              var json = cookies.get("checksList", { path: "/" });
              var checksList = json.list;
              var index = checksList.indexOf(companyId);
              if (index != -1) checksList.splice(index, 1);
              else checksList.push(companyId);

              cookies.set("checksList", JSON.stringify({ list: checksList }), {
                path: "/",
              });
            }}
          />

          {this.elementPdf ? this.elementPdf : null}

          <SendMailWidget
            ref={this.sendMailRef}
            show={this.state.sendMailVisible}
            onClose={() => this.setState({ sendMailVisible: false })}
            onSend={async (subject, body, file) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              this.mail = await getSetting(
                username,
                token,
                "sendingMailAddress"
              );
              this.mailPassword = await getSetting(
                username,
                token,
                "sendingMailPassword"
              );

              var corso = this.corsi.find(
                (s) => s.id == this.state.sendMailUserId
              );
              this.studentiCorso = this.studenti.filter((s) =>
                s.corsi
                  .split(";")
                  .filter(Boolean)
                  .includes(corso.id.toString())
              );

              if (file != undefined) {
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
              }

              var incorrectMails = [];

              var indirizzi = "";
              var nomi = "";

              this.studentiCorso.forEach(async (studente) => {
                studente.mail = studente.mail.trim();
                studente.mail2 = studente.mail2.trim();

                if (studente.mail != "") {
                  if (Utils.validateEmail(studente.mail) == false)
                    incorrectMails.push(studente.mail);
                  else {
                    indirizzi += studente.mail + "---";
                    nomi += studente.nome + " " + studente.cognome + "---";
                  }
                }
                if (studente.mail2 != "") {
                  if (Utils.validateEmail(studente.mail2) == false)
                    incorrectMails.push(studente.mail2);
                  else {
                    indirizzi += studente.mail2 + "---";
                    nomi += studente.nome + " " + studente.cognome + "---";
                  }
                }
              });

              if (incorrectMails.length > 0) {
                var msg =
                  "I seguenti indirizzo mail non sono corretti e sarebbero ignorati:\n";
                incorrectMails.forEach((mail) => (msg += mail + "\n"));
                msg += "Inviare comunque la mail?";

                if (window.confirm(msg) == false) return;
              }

              indirizzi = indirizzi.substring(0, indirizzi.length - 3);
              nomi = indirizzi.substring(0, indirizzi.length - 3);
              await sendMail(
                username,
                token,
                this.mail,
                "Accademia Nazionale del Cinema",
                this.mailPassword,
                indirizzi,
                nomi,
                file ? this.filePath.name : "",
                subject,
                body
              );

              this.setState({ waitDialogVisible: false });
              this.setState({ sendMailVisible: false });
            }}
          />

          <SendNotificationWidget
            ref={this.sendNotificationRef}
            show={this.state.sendNotificationVisible}
            onClose={() => this.setState({ sendNotificationVisible: false })}
            onSend={async (subject, body, bodyFull) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });

              var studentiCorso = await getStudenti(username, token);
              studentiCorso = studentiCorso.filter((s) =>
                s.corsi
                  .split(";")
                  .filter(Boolean)
                  .includes(this.state.notificationCorso.toString())
              );

              await addNotification(
                username,
                token,
                "CORSO",
                this.state.notificationCorso,
                subject,
                body,
                bodyFull,
                0
              );
              studentiCorso.forEach(async (studente) => {
                await addNotification(
                  username,
                  token,
                  "STUDENTE",
                  studente.id,
                  subject,
                  body,
                  bodyFull,
                  1
                );
              });

              this.setState({ waitDialogVisible: false });
              this.setState({ sendNotificationVisible: false });
            }}
          />

          <SelectPdfDatesWidget
            show={this.state.selectPdfDatesVisible}
            key={Math.random()}
            onCancel={() => console.log("Popup closed")}
            onOkClicked={(dateFrom, dateTo) => {
              const cookies = new Cookies();

              cookies.set("currentCorso", this.state.pdfElem, { path: "/" });
              console.log("currentCorso 1", this.state.pdfElem);

              // Formattazione date in formato gg/mm/aaaa per i cookie
              const formattedDateFrom = moment(dateFrom).format("DD/MM/YYYY");
              const formattedDateTo = moment(dateTo).format("DD/MM/YYYY");

              cookies.set("dateFrom", formattedDateFrom, { path: "/" });
              cookies.set("dateTo", formattedDateTo, { path: "/" });
              window.location.href = "#/app/pdfCorsoPage";
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </div>
    );
  }
}
